import { createSlice } from "@reduxjs/toolkit";
import { uniq } from "lodash";
import { possibleTagColors } from "components/modal/add-tag";
const initialState = {
    editTag: false,
    tagColor: possibleTagColors ? possibleTagColors[0] : undefined,
    tagItems: []
};
const slice = createSlice({
    initialState,
    name: "createTagReducers",
    reducers: {
        assignTagToItems: (state, action) => {
            if (!state.tagItems.find((tag) => tag.label === action.payload.label && tag.color === action.payload.color)) {
                state.tagItems.push({
                    color: action.payload.color,
                    entities: Array.isArray(action.payload.entity) ? action.payload.entity : [action.payload.entity],
                    isSelected: false,
                    label: action.payload.label
                });
                return;
            }
            state.tagItems = state.tagItems.map((tag) => {
                if (tag.label === action.payload.label && tag.color === action.payload.color) {
                    let newEntities = tag.entities;
                    if (Array.isArray(action.payload.entity)) {
                        newEntities = [...tag.entities, ...action.payload.entity];
                    }
                    else {
                        newEntities = [...tag.entities, action.payload.entity];
                    }
                    return {
                        ...tag,
                        entities: uniq(newEntities)
                    };
                }
                return tag;
            });
        },
        deleteTag: (state, action) => {
            state.tagItems = state.tagItems.filter((tag) => tag.label !== action.payload.label || tag.color !== action.payload.color);
        },
        removeTagFromItems: (state, action) => {
            state.tagItems = state.tagItems.map((tag) => {
                if (tag.label === action.payload.label && tag.color === action.payload.color) {
                    let newEntities = tag.entities;
                    if (Array.isArray(action.payload.entity)) {
                        newEntities = tag.entities.filter((entity) => !action.payload.entity.includes(entity));
                    }
                    else {
                        newEntities = tag.entities.filter((entity) => action.payload.entity !== entity);
                    }
                    return {
                        ...tag,
                        entities: uniq(newEntities)
                    };
                }
                return tag;
            });
        },
        resetTagState: () => initialState,
        setEditTag: (state, action) => {
            state.editTag = action.payload;
        },
        setEntityType: (state, action) => {
            state.entityType = action.payload;
        },
        setOldTag: (state, action) => {
            state.oldTag = action.payload;
        },
        setTagColor: (state, action) => {
            state.tagColor = action.payload;
        },
        setTagItems: (state, action) => {
            state.tagItems = action.payload;
        },
        setTagName: (state, action) => {
            state.tagName = action.payload;
        }
    }
});
export const { actions: { setTagColor, setTagName, setEntityType, setTagItems, assignTagToItems, removeTagFromItems, deleteTag, setEditTag, setOldTag, resetTagState }, reducer: TagReducers } = slice;
